import { render, staticRenderFns } from "./ConfirmationDelete.vue?vue&type=template&id=4e0c60c5&scoped=true&"
import script from "./ConfirmationDelete.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationDelete.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationDelete.vue?vue&type=style&index=0&id=4e0c60c5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c60c5",
  null
  
)

export default component.exports